export default {
  GET_OPEN_STATS: 'GET_OPEN_STATS',
};
